'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var GridToolbarFaresSurchargeUploadController = function GridToolbarFaresSurchargeUploadController($scope, $q, featureToggleService) {
  $scope.selectedRows = [];
  $scope.areEditingButtonsShown = !hasFileFareUpload();
  function hasRowModification(row) {
    return row._old;
  }
  function transformEntry(entry) {
    return {
      origin: entry.origin || '',
      destination: entry.destination || '',
      effectiveDate: entry.effectiveDate ? entry.effectiveDate.toISOString() : '',
      discontinueDate: entry.discontinueDate ? entry.discontinueDate.toISOString() : '',
      fareClass: entry.className || '',
      spos: entry.spos || 'Default'
    };
  }
  function isDuplicate(entry, allRows) {
    var fieldsToCheck = transformEntry(entry);
    var rowsIdenticalToModified = _.chain(allRows).transform(function (result, entry) {
      var newEntry = transformEntry(entry);
      return result.push(newEntry);
    }).filter(fieldsToCheck).value().length;
    return rowsIdenticalToModified > 1;
  }
  function doesRowContainEmptyField(entry) {
    return !entry.origin || !entry.destination || !entry.className || !entry.effectiveDate || !entry.discontinueDate || !_.has(entry, 'surcharge');
  }
  function validate(modifiedRows, allRows) {
    var promise = $q.defer();
    var isValidDuplicate = true;
    var isValidEmptyRow = true;
    var errorMessages = [];
    for (var i = 0; i < modifiedRows.length; i++) {
      if (!_.isUndefined(modifiedRows[i].origin) && modifiedRows[i].origin === modifiedRows[i].destination) {
        isValidDuplicate = false;
        errorMessages.push('Market Origin and Market Destination should not be same.');
      }
      if (isDuplicate(modifiedRows[i], allRows) && isValidDuplicate) {
        isValidDuplicate = false;
        errorMessages.push('Duplicate record exists');
      }
      if (doesRowContainEmptyField(modifiedRows[i]) && isValidEmptyRow) {
        isValidEmptyRow = false;
        errorMessages.push('Every column has to be filled');
      }
    }
    if (isValidDuplicate && isValidEmptyRow) {
      promise.resolve(modifiedRows);
    } else {
      promise.reject(errorMessages);
    }
    return promise.promise;
  }
  function validationSuccess(rows) {
    $scope.$emit('fares-surcharge-upload-grid:saveChanges', rows);
  }
  function validationFailure(messages) {
    for (var i = 0; i < messages.length; i++) {
      toastr.error(messages[i]);
    }
  }
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDeleteButtonShown = selectedRows.length > 0 && !hasFileFareUpload();
    $scope.isDuplicateButtonShown = selectedRows.length === 1 && !hasFileFareUpload();
    $scope.selectedRows = selectedRows;
  };
  $scope.saveChanges = function () {
    var allRows = $scope.jqxGridSettings.source.loadedData;
    var rows = _.chain(allRows).filter(hasRowModification).clone(true).value(true);
    if (rows.length > 0) {
      validate(rows, allRows).then(validationSuccess, validationFailure);
    } else {
      $scope.clearModifiedCells();
    }
  };
  function setStructureWithOldValues(loadedData, rowid) {
    loadedData[rowid]._old = {};
    var columns = $scope.jqxGridSettings.columns;
    _.forEach(columns, function (col) {
      loadedData[rowid]._old[col.datafield] = undefined;
    });
  }
  $scope.addSurcharge = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    loadedData.unshift({
      isNewlyAdded: true
    });
    setStructureWithOldValues(loadedData, 0);
    $scope.updateData(loadedData);
  };
  $scope.hidePOS = function () {
    $scope.jqxGridSettings.jqxGrid('hideColumn', 'spos');
    return true;
  };
  $scope.duplicateSurcharge = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var rowId = $scope.jqxGridSettings.jqxGrid('getselectedrowindex');
    var oldRow = loadedData[rowId];
    var newRow = _.clone(oldRow);
    newRow.isRowEditable = true;
    loadedData.splice(rowId, 0, newRow);
    setStructureWithOldValues(loadedData, rowId);
    $scope.updateData(loadedData);
  };
  function removeRowFromGrid(loadedData, selectedIndex) {
    _.remove(loadedData, function (value, index) {
      return _.includes(selectedIndex, index);
    });
    $scope.updateData(loadedData);
  }
  $scope.removeSurcharge = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var selectedIndexes = $scope.jqxGridSettings.jqxGrid('getselectedrowindexes');
    var rowsToRemoveFromServer = [];
    var idsToRemoveFromGrid = [];
    for (var i = 0; i < selectedIndexes.length; i++) {
      var row = loadedData[selectedIndexes[i]];
      if (row.isRowEditable || row.isNewlyAdded) {
        idsToRemoveFromGrid.push(selectedIndexes[i]);
      } else {
        rowsToRemoveFromServer.push(row);
      }
    }
    if (!_.isEmpty(rowsToRemoveFromServer)) {
      $scope.$emit('fares-surcharge-upload-grid:remove', rowsToRemoveFromServer);
    } else if (!_.isEmpty(idsToRemoveFromGrid)) {
      removeRowFromGrid(loadedData, selectedIndexes);
    }
  };
  $scope["import"] = function () {
    $scope.isImportValidationError = false;
    $scope.$emit('fares-surcharge-upload-grid:showImportModal');
  };
  $scope["export"] = function () {
    $scope.asyncGridApply('getdisplayrows').then(function (data) {
      $scope.$emit('fares-surcharge-upload-grid:export', data);
    });
  };
  $scope.$on('fares-surcharge-upload-grid:saveSuccess', function () {
    $scope.clearModifiedCells();
  });
  function hasFileFareUpload() {
    return featureToggleService.isDisabled('FIM') && featureToggleService.isEnabled('SERVICE_CLASS_CONTROL');
  }
};
GridToolbarFaresSurchargeUploadController.$inject = ['$scope', '$q', 'FeatureToggleService'];
module.exports = GridToolbarFaresSurchargeUploadController;